import { BaseButton } from '../base-button/base-button.component';
import { THEME } from '../../../../themes';
import { FilledButtonProps } from './filled-button';

export const FilledButton = ({
  Icon,
  buttonText,
  onClick,
  disabled,
  buttonRef,
  style,
}: FilledButtonProps): JSX.Element => {
  return (
    <BaseButton
      onClick={ onClick }
      Icon={ Icon }
      buttonText={ buttonText }
      disabled={ disabled }
      style={ {
        textColor: style?.textColor || THEME.COLORS.PURE_WHITE,
        backgroundColor: style?.backgroundColor ||  THEME.COLORS.ACCENT,
        activeBackgroundColor: style?.activeBackgroundColor || THEME.COLORS_RGB.ACCENT_024,
        hoveredBackgroundColor: style?.hoveredBackgroundColor || THEME.COLORS_RGB.ACCENT_012,
        uppercase: style?.uppercase || true,
      } }
      buttonRef={ buttonRef }
    />
  );
};

FilledButton.defaultProps = {
  buttonRef: undefined,
  Icon: undefined,
  disabled: false,
};
